import { ToelichtingWerkloosheidHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import React, { ReactElement } from "react";
import { PageBreak } from "../../../components/PageBreak";
import Heading from "../../../components/Heading";
import { Paragraph } from "../../../components/Paragraph";
import { Chapter } from "../../../components/Chapter";
import { ScenarioWerkloosheidChapter } from "./scenario-werkloosheid-chapter";

type ToelichtingWerkloosheidChapterProps = {
  hoofdstuk: ToelichtingWerkloosheidHoofdstuk;
};

export const ToelichtingWerkloosheidChapter = ({
  hoofdstuk,
}: ToelichtingWerkloosheidChapterProps): ReactElement => {
  return (
    <>
      <PageBreak />
      <Chapter>
        <Heading level={2} text={hoofdstuk.titel} />
        <Paragraph paragraaf={hoofdstuk.paragrafen?.p3060501} />
        {hoofdstuk.motivering?.some((x) => x.klantVolgnummer === 1) && (
          <ScenarioWerkloosheidChapter
            scenarioWerkloosheid={hoofdstuk}
            selectedAanvrager="Aanvrager1"
          />
        )}
        {hoofdstuk.motivering?.some((x) => x.klantVolgnummer === 2) && (
          <>
            {hoofdstuk.motivering?.some((x) => x.klantVolgnummer === 1) && (
              <PageBreak />
            )}
            <ScenarioWerkloosheidChapter
              scenarioWerkloosheid={hoofdstuk}
              selectedAanvrager="Aanvrager2"
            />
          </>
        )}
      </Chapter>
    </>
  );
};
